import React, { useEffect, useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import { getSiteSettings } from '../providers/authService';
import { clearTelemetryUser, flushTelemetry } from '../lib/telemetry';

export default function Signout() {
  const auth = useAuth();
  const { redirect } = getSiteSettings();

  const handleSignout = useCallback(() => {
    // Send what is buffered before the redirect discards the page, and stop attributing
    // telemetry to a user who is on their way out.
    flushTelemetry();
    clearTelemetryUser();
    setTimeout(() => {
      auth.signoutRedirect({
        post_logout_redirect_uri: redirect,
      });
    }, 1000);
  }, [auth, redirect]);

  useEffect(() => {
    handleSignout();
  }, [auth, handleSignout, redirect]);

  return (
    <>
      <div>Signing you out...</div>
    </>
  );
}
